// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-text[data-v-0a11d1e4]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.component-text[data-v-0a11d1e4],.component-text__item[data-v-0a11d1e4]{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex}.component-text--selected .component-text__item[data-v-0a11d1e4]{border:10px dotted #f37053}", ""]);
// Exports
module.exports = exports;
